import React, { useEffect, useState } from "react";
import PWAGuideSnackbar from "container/snackbar/PWAGuideSnackbar";
import CookieConsentSnackbar from "container/snackbar/CookieConsentSnackbar";

function RootSnackbar(props) {
  const [firstSnackbarOpen, setFirstSnackbarOpen] = useState(false);
  const [secondSnackbarOpen, setSecondSnackbarOpen] = useState(false);

  useEffect(() => {
    initSnackbar();
  }, []);

  const initSnackbar = () => {
    setFirstSnackbarOpen(true);
    setSecondSnackbarOpen(true);
  };

  return (
    <div>
      <CookieConsentSnackbar
        readyToShow={firstSnackbarOpen}
        complitionCallbackFn={() => {}}
      />
      <PWAGuideSnackbar readyToShow={secondSnackbarOpen} />
    </div>
  );
}

export default RootSnackbar;
